module.exports = "<p>\r\n  blank works!\r\n</p>\r\n"